import { Injectable } from '@angular/core';
import { SensorObject } from '../asp/SensorObject';
import { MatDialog, MatDialogRef, MatDialogState } from '@angular/material/dialog';
import { AroSensorComponent } from './aro-sensor.component';
import * as pako from 'pako'; // Import pako for GZIP decompression
import { IService } from '@core_n/asp/interfaces';
import { sensorsPool } from '@core_n/asp/aspObjects';

@Injectable({
  providedIn: 'root'
})
export class AroSensorService implements IService {
  private dialogRef: MatDialogRef<any>;
  private dialogRefArr: MatDialogRef<any>[] = [];
  constructor(private dialog: MatDialog) { }

  showWindow(sensor: SensorObject, isEditCamera: boolean = false) {
    this.dialogRef = this.getFromArr(sensor.sensorID);
    let sensorComp: AroSensorComponent;
    sensor.isEditCamera = isEditCamera;
    sensor.isNewCamera = false;
    if (this.dialogRef && this.dialogRef.getState() == MatDialogState.OPEN) {
      sensorComp = this.dialogRef.componentInstance as AroSensorComponent;
      sensorComp.setSensor(sensor);
      sensorComp.dialogRaise();
    }
    else {
      this.dialogRef = this.dialog.open(AroSensorComponent, AroSensorComponent.createDialogConfig(sensor));
      this.dialogRefArr.push(this.dialogRef);
      sensorComp = this.dialogRef.componentInstance as AroSensorComponent;
      sensorComp.setSensor(sensor);
      sensorComp.dialogRaise();
    }
  }

  showWindowNewSensor() {
    this.dialogRef = this.getFromArr(0);
    let sensorComp: AroSensorComponent;
    let sensor = new SensorObject(sensorsPool, 0, "");
    sensor.isNewCamera = true;
    // sensor.SensorType = "Video";
    if (this.dialogRef && this.dialogRef.getState() == MatDialogState.OPEN) {
      sensorComp = this.dialogRef.componentInstance as AroSensorComponent;
      sensorComp.setSensor(sensor);
      sensorComp.dialogRaise();
    }
    else {
      this.dialogRef = this.dialog.open(AroSensorComponent, AroSensorComponent.createDialogConfig(sensor));
      this.dialogRefArr.push(this.dialogRef);
      sensorComp = this.dialogRef.componentInstance as AroSensorComponent;
      sensorComp.setSensor(sensor);
      sensorComp.dialogRaise();
    }
  }

  getFromArr(num: number): any {
    let Ref: MatDialogRef<any> = null;
    this.removeGarbage();
    this.dialogRefArr.forEach((ref) => {
      let refSensorAro = ref.componentInstance as AroSensorComponent;
      if (refSensorAro) {
        if (num == refSensorAro.sensorId) {
          Ref = ref;
          return;
        }
      }
    })
    return Ref;
  }

  removeGarbage() {
    this.dialogRefArr = this.dialogRefArr.filter(ele => {
      return (ele != null && ele !== undefined && ele.getState() != MatDialogState.CLOSED);
    })
  }
}
